import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setUserData } from "../../../Redux/user_information";
import { useDispatch } from "react-redux";

// Import FontAwesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faSignInAlt } from '@fortawesome/free-solid-svg-icons';

// Import CSS
import "../../../Register Styles/bootstrap.min.css";
import "../../../Register Styles/style.css";
import { adminLoginApi } from "../../../Services/Operations/ProductAPI";

const AdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [formData, setFormData] = useState({
    login_id: "",
    password: ""
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Check if already logged in
//   useEffect(() => {
//     const token = localStorage.getItem('adminToken');
//     if (token) {
//       navigate('/admin/dashboard');
//     }
//   }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (error) setError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    if (!formData.login_id.trim()) {
      setError('Please enter login ID');
      toast.error('Please enter login ID');
      return false;
    }

    if (!formData.password) {
      setError('Please enter admin password');
      toast.error('Please enter admin password');
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const result = await adminLoginApi(formData.login_id, formData.password);

      if (result.status === true) {
        console.log('Admin login successful:', result);
        toast.success(result.message || 'Admin login successful!');

        // Store admin token and data
        const token = result.token;
        
        // Store admin data in redux
        dispatch(setUserData({
          userData: result.data || {},
          token: token,
          rememberMe: false,
          isAdmin: true
        }));

        // Store in localStorage
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminData', JSON.stringify(result.data || {}));
        localStorage.setItem('loginTime', new Date().toISOString());

        // Navigate to admin dashboard
        navigate('/admin/dashboard');
        
      } else {
        const errorMessage = result.message || 'Admin login failed. Please check your credentials.';
        setError(errorMessage);
        toast.error(errorMessage);
      }

    } catch (error) {
      console.error('Admin login error:', error);
      setError('An error occurred during admin login. Please try again.');
      toast.error('An error occurred during admin login. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page_wrapper">
      <main className="page_content">
        <section className="register_section section_decoration">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 position-relative">
                <div className="card shadow-lg border-0" style={{ 
                  backgroundColor: '#1a1a2e',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                  <div className="card-body p-4">
                    {/* Header */}
                    <div className="text-center mb-4">
                      <h1 className="heading_text text-white mb-2">Admin Login</h1>
                    
                      <div className="mt-3" style={{ 
                        width: '60px', 
                        height: '3px', 
                        backgroundColor: '#4f46e5', 
                        margin: '0 auto',
                        borderRadius: '2px'
                      }}></div>
                    </div>

                    {/* Login Form */}
                    <form onSubmit={handleSubmit}>
                      {/* Login ID Input */}
                      <div className="form-group mb-4">
                        <label className="input_title text-white" htmlFor="input_login_id">
                          Login ID
                        </label>
                        <input
                          id="input_login_id"
                          className={`form-control ${error ? 'is-invalid' : ''}`}
                          type="text"
                          name="login_id"
                          value={formData.login_id}
                          onChange={handleInputChange}
                          placeholder="Enter login ID"
                          required
                          disabled={isSubmitting}
                          autoComplete="off"
                          style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            color: '#fff',
                            padding: '12px 15px'
                          }}
                        />
                      </div>

                      {/* Password Input */}
                      <div className="form-group mb-4">
                        <label className="input_title text-white" htmlFor="input_password">
                          Password
                        </label>
                        <div className="password-input-group" style={{ position: 'relative' }}>
                          <input
                            id="input_password"
                            className={`form-control ${error ? 'is-invalid' : ''}`}
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Enter password"
                            required
                            disabled={isSubmitting}
                            style={{
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                              border: '1px solid rgba(255, 255, 255, 0.1)',
                              color: '#fff',
                              padding: '12px 45px 12px 15px',
                              paddingRight: '45px'
                            }}
                            autoComplete="off"
                          />
                          <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={togglePasswordVisibility}
                            disabled={isSubmitting}
                            style={{
                              position: 'absolute',
                              right: '12px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              background: 'none',
                              border: 'none',
                              color: 'rgba(255, 255, 255, 0.5)',
                              cursor: 'pointer',
                              padding: '5px',
                              zIndex: 2,
                              fontSize: '16px'
                            }}
                          >
                            <FontAwesomeIcon 
                              icon={showPassword ? faEyeSlash : faEye} 
                            />
                          </button>
                        </div>
                        {error && (
                          <div className="invalid-feedback d-block text-danger mt-2">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            {error}
                          </div>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="form-group mb-3">
                        <button
                          className="btn w-100"
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: '#4f46e5',
                            border: 'none',
                            color: 'white',
                            padding: '12px',
                            fontSize: '16px',
                            fontWeight: '600',
                            borderRadius: '8px',
                            transition: 'all 0.3s',
                            position: 'relative',
                            height: '48px'
                          }}
                          onMouseEnter={(e) => {
                            if (!isSubmitting) {
                              e.currentTarget.style.backgroundColor = '#4338ca';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSubmitting) {
                              e.currentTarget.style.backgroundColor = '#4f46e5';
                              e.currentTarget.style.transform = 'translateY(0)';
                            }
                          }}
                        >
                          {isSubmitting ? (
                            <>
                              <span className="me-2">Authenticating...</span>
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                              <span>Admin Login</span>
                            </>
                          )}
                        </button>
                      </div>

                    </form>
                  </div>
                </div>

                {/* Footer Note */}
                {/* <div className="text-center mt-4">
                  <p className="text-muted small">
                    &copy; {new Date().getFullYear()} Willow Quantum Admin
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Add custom styles */}
      <style jsx="true">{`
        .form-control:focus {
          box-shadow: 0 0 0 0.2rem rgba(79, 70, 229, 0.25);
          border-color: #4f46e5;
        }
        
        .invalid-feedback {
          font-size: 0.875rem;
        }
        
        .card {
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }
        
        .password-toggle-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default AdminLogin;